module.exports = __webpack_public_path__ + "img/minus.5cdb0617.svg";